import React from 'react';

export function Footer() {
    return(
        <footer className="credit">
            Source of names list: {" "}
            <a
                href="https://www.yahoo.com/parenting/atticus-tops-baby-names-2015-124073377716.html"
                target="_blank"
                rel="noopener noreferrer"
            >
                Yahoo - Top baby names in 2015
            </a>
        </footer>
    )
}